import {apiConfig} from "./apiConfig";
export function getDisplayServicesList(postalCode:any,serviceModifier:any,successHandler:any,errorHandler:any){
    var webloc = window.objOSGlobal.requestBodyValues.WebLocationId;
    var query = 'FranchiseWebLocationId='+webloc;
    $.ajax({
        type: "GET",
        url:apiConfig.serviceWebcategoriesLeadAggregates+encodeURI(query)+'&ServiceModifier='+serviceModifier+'&ZipCode='+postalCode+'&apikey=' + window.DEFINE_VALUE.JS_API_KEY,
        contentType: "application/json",
        dataType: 'json',
        success: successHandler,
        error: errorHandler
    });
}